import { jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { Tooltip } from "../Tooltip/index.js";
import { KSTATUS_CIRCLE_SIZE_CLASSES } from "./constants.js";
const StatusCircle = ({ size, status: statusProp, userName, className })=>{
    const sizeClasses = KSTATUS_CIRCLE_SIZE_CLASSES[size];
    const status = 'online' === statusProp ? 'Online' : 'Offline';
    const label = `${userName?.concat(' ') || ''}(${status})`;
    return /*#__PURE__*/ jsx(Tooltip, {
        label: label,
        position: "bottom",
        type: "small",
        children: /*#__PURE__*/ jsx("span", {
            className: clsx([
                'tw-absolute',
                'tw-rounded-full',
                'tw-border-neutral-light-100'
            ], className, sizeClasses)
        })
    });
};
export { StatusCircle };
